import { Module } from 'vuex';
import { BusinessSystemState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: BusinessSystemState = {
    businessSystems: undefined,
    businessSystemCount: 0,
    businessSystemDetails: {
        businessSystem: undefined,
    },
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const businessSystem: Module<BusinessSystemState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
